export default "__VITE_ASSET__pBd_c_vi__"